export default "__VITE_ASSET__913e635a__"